<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 5v3h-4.5v12h-3V8H6V5h12zm-1.217 10l.444.806c.131.283.282.575.423.857h.04c.102-.282.233-.574.343-.857l.343-.806h1.532l-1.451 2.57L19.999 20h-1.593l-.483-.827-.474-.867h-.04c-.121.283-.263.575-.384.867l-.393.827H15.1l1.532-2.6-1.441-2.4h1.592z" fill-rule="evenodd"/>
</svg>
